<div class="ibox-content no-scroll-mode h-100">
    <div class="row">
        <div class="col-sm-7">
            <filter [tabHeading]="'Amenity'" [buildings]="settingsIntegrationsService.buildingsForRead"></filter>
        </div>

        <settings-integrations-filter></settings-integrations-filter>

        <div *ngIf="settingsIntegrationsService.canEdit()" class="col-sm-3">
            <button type="button" class="btn btn-w-m btn-primary pull-right"
                    (click)="goToAppsList()">
                <i class="fa fa-plus-circle"></i> New Integrations
            </button>
        </div>

    </div>
    <div class="row">
        <div class="col-sm-12">
            <filters-view></filters-view>
        </div>
    </div>
    <tabs-wrapper>
        <tab-item [tabId]="'allSettingsAmenities'" [active]="true" [ngClass]="{'sk-loading': settingsIntegrationsService.spinnerShow}">
            <div class="table-responsive" [class.overflow-hidden]="settingsIntegrationsService.emptyRowService.emptyRow.length > 0">
                <table class="table table-striped table-hover service-request-list-table footable">
                    <thead>
                    <tr [ngClass]="{'noSort': settingsIntegrationsService.data.corporations.data.length < 2}">
                        <th></th>
                        <th (click)="orderBy('name', $event)">App Name<span class="footable-sort-indicator"></span></th>
                    </tr>
                    </thead>
                    <tbody>
                    <ng-template ngFor let-item [ngForOf]="settingsIntegrationsService.data.corporations.data" let-index="index">
                        <tr [ngClass]="{'footable-odd': (index % 2 === 0)}" (click)="$event.showDropdown || toggleCheck(item)">
                            <td>
                                <label class="img-checkbox">
                                    <input type="checkbox" [ngModel]="item.checked">
                                    <label><svg-checked></svg-checked></label>
                                </label>
                            </td>
                            <td>{{item.name}}</td>
                        </tr>
                    </ng-template>
                    <tr *ngFor="let item of settingsIntegrationsService.emptyRowService.emptyRow" style="cursor: default;">
                        <td></td><td>&nbsp;</td>
                    </tr>
                    </tbody>
                </table>
                <h2 *ngIf="settingsIntegrationsService.data.corporations.total == 0 && !settingsIntegrationsService.showServiceUnavailable" class="text-center">Result Not Found</h2>
                <h2 *ngIf="settingsIntegrationsService.showServiceUnavailable" class="text-center">Service Unavailable</h2>
            </div>
            <spinner [spinnerShow]="settingsIntegrationsService.spinnerShow"></spinner>
        </tab-item>
        <pagination *ngIf="settingsIntegrationsService.data.corporations.total && urlService.queryParams['page']"
                    [total]="settingsIntegrationsService.data.corporations.total"></pagination>
    </tabs-wrapper>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-integrations/settings-integrations-list/settings-integrations-list.component.html